import { getComposeEvent } from 'owa-calendar-compose-store-manager';
import { getCalendarIdByFolderId } from 'owa-calendar-cache';
import { isHostAppFeatureEnabled } from 'owa-hostapp-feature-flags';
import { isFeatureEnabled } from 'owa-feature-flags';

export function shouldShowFormHeader(formId: string) {
    const event = getComposeEvent(formId);
    const calendarId = getCalendarIdByFolderId(event.ParentFolderId.Id);

    return (
        isHostAppFeatureEnabled('composeFormHeader') ||
        (calendarId && isFeatureEnabled('cal-mf-calendarPickerTeams'))
    );
}
